import React, { useEffect } from "react";
import Chart from 'chart.js';

export default function PieChart(props) {
  useEffect(() => {
    displayChart();
  }, [props.data]);

  const displayChart = () => {
    Chart.defaults.global.defaultFontFamily = "Lato";
    Chart.defaults.global.defaultFontSize = 16;
    const node = document.getElementById(props.id);
    let teamPerformanceChart = new Chart(node, {
      type: "pie",
      data: props.data,
      options: {
        legend: {
          position: "bottom",
          align: "start",
          labels: {
            usePointStyle: true,
            fontSize: props.fontSize,
        
          }
        },
        elements: {
          line: {
            tension: 0
          }
        },
      }
    });
    props.setTeamPerformanceChart(teamPerformanceChart);  
        
  }
  return (
    <div className="">
      <canvas id={props.id} className={props.pie} />
    </div>
  );
}